import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

const ThemeOverview = (props) => {
    const [result, setResult] = useState([]);

    useEffect(() => {
        setResult(props.posts);
    });

    const render = result.map((value, index) => {
        if (result === undefined) {
            return '';
        }

        return (
            <div className="theme__article" key={index}>
                <div className="readmore__inner-container readmore__inner-container--black readmore__inner-container--gutter">
                    <h3 className="text__color--white readmore__title--theme">
                        {ReactHtmlParser(result[index].title.rendered)}
                    </h3>
                    <Link
                        className="cta-btn white"
                        to={`/themes/${result[index].slug}`}>
                        View theme
                    </Link>
                </div>
            </div>
        );
    });
    return (
        <React.Fragment>
            <h1 className="theme__pagetitle fadeIn">Themes</h1>
            <div className="theme__holder fadeIn">{render}</div>
        </React.Fragment>
    );
};
export default ThemeOverview;



// WEBPACK FOOTER //
// ./src/components/Pages/Themes/ThemeOverview.jsx